<div
  [ngClass]="{ 'to-top-button--hidden': !isVisible }"
  class="to-top-button"
  (click)="scrollToTop()"
  (keydown)="scrollToTop()"
>
  <hdi-button
    [type]="ButtonType.BACK_TO_TOP"
    [iconPrefix]="'far'"
    [label]="'Zurück nach oben'"
  >
  </hdi-button>
</div>
